/* eslint-disable @typescript-eslint/no-explicit-any */
import { UnwrapRef } from '@nuxtjs/composition-api';

import { formatPrice } from '~/components/bloczki/components/bloczki-functions/bloczek-cena/getBloczekCena';
import { IBloczek } from '~/components/bloczki/types/IBloczek';
import { IClusterCalculatorDefinition } from '~/components/map/types/cluster/IClusterCalculatorDefinition';
import IGoogleMapState from '~/components/map/types/mapState';
import { BloczekMarker } from '~/components/map/types/marker/BloczekMarker';

import getMarkerPosition from '../marker/getMarkerPosition';

const calculator = (
  gmapMarkers: any[],
  googleMapState: UnwrapRef<IGoogleMapState<BloczekMarker, IBloczek>>,
): IClusterCalculatorDefinition => {
  const clusterableMarkers = googleMapState.inactiveMarkers ? googleMapState.inactiveMarkers : [];
  const clusteredMarkers = clusterableMarkers.filter((marker: any) => {
    const pos = getMarkerPosition(marker);

    return gmapMarkers.find((gmapElem: any) => {
      const gmapElemPos = gmapElem.getPosition();

      return gmapElemPos.lat() === pos.lat && gmapElemPos.lng() === pos.lng;
    });
  });
  const pricesArr: number[] = clusteredMarkers.map((marker: BloczekMarker) => marker.Cena);
  const minPrice: number = Math.min(...pricesArr);
  const minPriceText: string = formatPrice(minPrice);
  const htmlText = `<div class="cluster cluster-wrapper"><div class="cluster__count">${gmapMarkers.length}</div><div class="cluster__price">od ${minPriceText} zł</div></div>`;

  return {
    index: 0,
    text: htmlText,
  };
};
export default calculator;
